const getters = {
  userInfo: state => state.user.userInfo,
  isLogin: state => state.user.isLogin,
  rememberLogin: state => state.user.rememberLogin,
  productQuantity: state => state.user.productQuantity,
  token: state => state.user.token,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js